// removed by extract-text-webpack-plugin
module.exports = {"doubleTable":"common_doubleTable_2GmBm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/common/common.scss
// module id = 292
// module chunks = 0